import { apiUrl } from '../config/runtime';

const REPORT_PATH = '/client-errors';
let handlersInstalled = false;

const serializeError = (error) => {
  if (!error) return null;
  return {
    message: error.message || String(error),
    name: error.name || 'Error',
    stack: error.stack || null,
  };
};

export function reportClientError(kind, error, extra = {}) {
  const payload = {
    kind,
    url: typeof window !== 'undefined' ? window.location.href : '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    timestamp: new Date().toISOString(),
    error: serializeError(error),
    extra,
  };

  const endpoint = apiUrl(REPORT_PATH);
  if (!endpoint) {
    console.error('[monitoring]', payload);
    return;
  }

  const body = JSON.stringify(payload);
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      const queued = navigator.sendBeacon(endpoint, blob);
      if (queued) return;
    }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    console.error('[monitoring]', payload);
  }
}

export function installGlobalErrorHandlers() {
  if (handlersInstalled || typeof window === 'undefined') return;
  handlersInstalled = true;

  window.addEventListener('error', (event) => {
    reportClientError('window_error', event.error || new Error(event.message || 'Window error'), {
      filename: event.filename || null,
      lineno: event.lineno || null,
      colno: event.colno || null,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(typeof event.reason === 'string' ? event.reason : 'Unhandled promise rejection');
    reportClientError('unhandled_rejection', reason);
  });
}